import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';

const defaultMessage =
  'Your account is currently on hold. Please contact support for assistance.';

const OnHold: FC = () => {
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message') || defaultMessage;

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        On Hold
      </Typography>
      <Typography variant="body1">{message}</Typography>
    </Box>
  );
};

export default OnHold;
